import RefereeFaultSheet from "../../shared/RefereeFaultSheet";
import { PICKLEBALL_FAULT_TYPES } from "../engine/createPickleballMatchEngine";

/**
 * Referee Fault sheet for pickleball — shared sheet + sport fault list.
 */
export default function PickleballRefereeExtras(props) {
  return (
    <RefereeFaultSheet
      {...props}
      faultTypes={PICKLEBALL_FAULT_TYPES}
      testId="pickleball-referee-extras"
      serveDisplay={props.serveDisplay ? `Serve ${props.serveDisplay}` : null}
    />
  );
}
